<template>
  <div class="sideBar">
    <el-row class="tac">
      <el-col>
        <div class="logo">
          <a href="/">
            <img src="../../assets/imgs/logo.jpg" alt="">
          </a>
        </div>
        <el-menu :default-active="activeIndex" class="el-menu-vertical alc-side-menu">
          <el-menu-item v-for="(menu, key) in menus" :key="key" :index="'/' + menu.path" @click="menuClick(menu)">
            <i :class="menu.icon"></i>
            <span v-if="menu.title === '待办事项'">
              <span v-if="todoNum > 0">
                <el-badge :value="todoNum" :max="99" class="item">
                  {{ menu.title }}
                </el-badge>
              </span>
              <span v-else>
                {{ menu.title }}
              </span>
            </span>
            <span v-else>
              {{ menu.title }}
            </span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import router from '../../router'

export default {
  name: 'SideBar',
  data() {
    return {
      activeIndex: '/dashboard',
      menus: this.$menu,
      showUserInfoBox: false,
      todoNum: 0
    }
  },
  created() {
    this.activeIndex = this.$route.path
  },
  mounted() {
    this.activeIndex = this.$route.path;
    // this.queryTodoList();
    // this.intervals = setInterval(() => {
    //   this.queryTodoList();
    // }, 10000);
  },
  methods: {
    menuClick(menu) {
      this.$router.push('/' + menu.path)
        .catch((error) => { });
    },
    handleOpen() { },
    handleClose() { },
    queryTodoList() {
      if (Object.keys(this.$userinfo).length === 0) {
        return;
      }
      this.$axios.get(`schedule/todolist_count`).then((response) => {
        if (response.data.code === 200) {
          this.todoNum = response.data.data
        }
        setTimeout(() => {
          this.queryTodoList();
        }, 1000);
      });
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.sideBar {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.logo {
  width: 100%;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo a {
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo img {
  width: 65px;
  height: 65px;
}

.el-menu /deep/ {
  border: none;
}

.tac {
  height: 100%;
  border-right: solid 1px #e6e6e6;
}

a {
  color: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/Global/SideBar.vue